import { useEffect } from "react";
import { matchesModShortcut, type ModShortcutKey } from "~/lib/keyboard-shortcuts";

/**
 * Calls `onPress` when the `MOD_SHORTCUTS` entry for `key` is pressed anywhere on the page.
 *
 * Args:
 *   key: The registered shortcut letter.
 *   onPress: Called on each press; pass a stable function to avoid resubscribing.
 *   enabled: Whether the shortcut is bound at all.
 */
export function useModShortcut(key: ModShortcutKey, onPress: () => void, enabled = true) {
  useEffect(() => {
    if (!enabled) {
      return;
    }
    const onKeyDown = (event: KeyboardEvent) => {
      if (!matchesModShortcut(event, key)) {
        return;
      }
      event.preventDefault();
      onPress();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [key, onPress, enabled]);
}
